import React from 'react'
import { Box, Heading } from 'react-bulma-components'
import { PeriodSummaryCancellationRequest } from '../../../../../backend/src/services/resources/period-summaries/period-summary.types'
import Avatar from '../../../components/avatar/avatar'
import { localDate } from '../../../utils/date'

export interface PreBillingCancellationHistoryProps {
  /** Archived cancellation requests (newest first in UI). */
  entries: PeriodSummaryCancellationRequest[]
}

/**
 * Displays the cancellation workflow history for a three-parties pre-billing.
 */
const PreBillingCancellationHistory: React.FC<PreBillingCancellationHistoryProps> = ({
  entries,
}) => {
  if (!entries?.length) return null

  const ordered = [...entries].sort(
    (a, b) => new Date(b.requestedAt).getTime() - new Date(a.requestedAt).getTime(),
  )

  return (
    <Box mt={4}>
      <Heading size={5} mb={3}>
        Historique des demandes d&apos;annulation
      </Heading>
      {ordered.map((entry, index) => (
        <Box
          key={`${String(entry.requestedAt)}-${index}`}
          backgroundColor="light"
          mb={3}
          p={4}
          style={{ borderRadius: 4 }}
        >
          <p className="mb-2">
            <strong>Initiateur :</strong>{' '}
            {entry.requesterRole === 'employerMember' ? 'Employeur' : "Agence d'intérim"}
          </p>
          <p className="mb-2 is-flex is-align-items-center" style={{ gap: 8 }}>
            <Avatar user={entry.requestedBy as any} />
            <span>
              {localDate(entry.requestedAt)} — <em>{entry.requestComment}</em>
            </span>
          </p>
          {entry.decision && (
            <>
              <p className="mb-2">
                <strong>Décision :</strong> {entry.decision === 'accepted' ? 'Acceptée' : 'Refusée'}
              </p>
              {entry.resolvedBy && (
                <p className="mb-2 is-flex is-align-items-center" style={{ gap: 8 }}>
                  <Avatar user={entry.resolvedBy as any} />
                  <span>
                    {entry.resolvedAt ? `${localDate(entry.resolvedAt)} — ` : ''}
                    <em>{entry.resolutionComment}</em>
                  </span>
                </p>
              )}
            </>
          )}
        </Box>
      ))}
    </Box>
  )
}

export default PreBillingCancellationHistory
